var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.721,
    height: 21.299,
    viewBox: "0 0 25.721 21.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8 -15.3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.2 15.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.631,29.1H41.3a.3.3,0,0,0-.3.3V34.1a.3.3,0,0,0,.3.3H51.631a.3.3,0,0,0,.3-.3V29.4A.3.3,0,0,0,51.631,29.1Zm-.3,4.725H41.606V29.706h9.723Z",
    transform: "translate(-31.065 -24.981)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8,15.5a2.12,2.12,0,0,0-2.12,2.12v2.393H10.32a2.12,2.12,0,0,0-2.12,2.12V33.37A3.029,3.029,0,0,0,11.229,36.4H29.8a3.726,3.726,0,0,0,3.726-3.726V17.62A2.12,2.12,0,0,0,31.4,15.5ZM11.259,35.794A2.423,2.423,0,0,1,8.836,33.37V22.133a1.514,1.514,0,0,1,1.514-1.514h3.332V33.37a2.423,2.423,0,0,1-2.453,2.423ZM32.946,17.62V32.674a3.12,3.12,0,0,1-3.15,3.12H13.046a3.029,3.029,0,0,0,1.212-2.423V17.62a1.514,1.514,0,0,1,1.514-1.514H31.4a1.514,1.514,0,0,1,1.514,1.514Z",
    transform: "translate(-8.2 -15.5)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.631,56.6H41.3a.3.3,0,0,0,0,.606H51.631a.3.3,0,1,0,0-.606Z",
    transform: "translate(-31.065 -44.151)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.631,68.6H41.3a.3.3,0,0,0,0,.606H51.631a.3.3,0,1,0,0-.606Z",
    transform: "translate(-31.065 -52.517)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.4bbfcdf0.svg";
export { ForwardRef as ReactComponent };